import React, { useEffect, useState } from 'react';
export function UrgencyBanner() {
  const [spotsTaken, setSpotsTaken] = useState(() => {
    const saved = sessionStorage.getItem('reflexo-spots');
    if (saved) {
      const {
        value,
        timestamp
      } = JSON.parse(saved);
      const elapsed = (Date.now() - timestamp) / 1000;
      const increment = Math.floor(elapsed / 45) * 1;
      return Math.min(value + increment, 94);
    }
    return 62 + Math.floor(Math.random() * 6);
  });
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 27,
    s: 35
  });
  useEffect(() => {
    sessionStorage.setItem('reflexo-spots', JSON.stringify({
      value: spotsTaken,
      timestamp: Date.now()
    }));
  }, [spotsTaken]);
  useEffect(() => {
    const interval = setInterval(() => {
      setSpotsTaken(prev => {
        if (prev >= 94) return prev;
        const increment = Math.random() < 0.3 ? 1 : 0;
        return Math.min(prev + increment, 94);
      });
    }, 30000 + Math.random() * 30000);
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) {
          s--;
        } else {
          s = 59;
          if (m > 0) {
            m--;
          } else {
            m = 59;
            if (h > 0) h--;
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  return <div className="w-full bg-brand-rose text-white py-2 px-4 z-50 pt-[1px] pb-[1px] pl-[1px] pr-[1px]" data-id="element-283">
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-center" data-id="element-284">
        <span className="font-serif font-bold text-sm sm:text-base" data-id="element-285">
          ⏰ PRECIO DE LANZAMIENTO
        </span>

        <div className="flex items-center gap-1 font-mono font-bold text-sm sm:text-base" data-id="element-286">
          <span className="bg-white/20 px-1.5 py-0.5 rounded text-xs sm:text-sm" data-id="element-287">
            {fmt(timeLeft.h)}h
          </span>
          <span data-id="element-288">:</span>
          <span className="bg-white/20 px-1.5 py-0.5 rounded text-xs sm:text-sm" data-id="element-289">
            {fmt(timeLeft.m)}m
          </span>
          <span data-id="element-290">:</span>
          <span className="bg-white/20 px-1.5 py-0.5 rounded text-xs sm:text-sm" data-id="element-291">
            {fmt(timeLeft.s)}s
          </span>
        </div>

        <span className="hidden sm:inline text-white/60" data-id="element-292">|</span>

        <div className="flex items-center gap-2 text-xs sm:text-sm" data-id="element-293">
          <span className="font-medium" data-id="element-294">🔴 {spotsTaken}% cupos tomados</span>
          <div className="w-20 bg-white/30 rounded-full h-1.5 overflow-hidden" data-id="element-295">
            <div className="bg-white h-1.5 rounded-full transition-all duration-1000 ease-out" style={{
            width: `${spotsTaken}%`
          }} data-id="element-296" />
          </div>
        </div>
      </div>
    </div>;
}